import React, { useCallback } from 'react';
import {
  FormControl,
  FormLabel,
  Input,
  InputGroup,
  Text,
  useColorModeValue,
} from '@chakra-ui/react';

const InputBox = ({
  errors,
  name,
  label,
  register,
  onChange,
  type,
  placeholder,
  ...props
}) => {
  const textColor = useColorModeValue('navy.700', 'white');

  const handleOnChange = useCallback(
    (e) => {
      if (onChange) onChange(e);
    },
    [onChange],
  );

  return (
    <>
      <FormControl isInvalid={!!errors[name]} mb="24px">
        <FormLabel
          display="flex"
          ms="4px"
          fontSize="sm"
          fontWeight="500"
          color={textColor}
        >
          {label}
          {/* <Text color={brandStars}>*</Text> */}
        </FormLabel>
        <InputGroup size="md">
          <Input
            variant="auth"
            fontSize="sm"
            placeholder={placeholder || `Enter ${label}`}
            size="lg"
            borderColor={errors[name] ? 'red.500' : 'inherit'}
            {...register(name)}
            onChange={handleOnChange}
            {...props}
          />
        </InputGroup>
        {errors[name] && (
          <Text color="red.500" fontSize="sm" mt="2">
            {errors[name].message}
          </Text>
        )}
      </FormControl>
    </>
  );
};

export default InputBox;
